import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-783a85fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mask" }
const _hoisted_2 = {
  key: 0,
  class: "expire-img"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  id: "lottie-main"
}

import { ref, computed, onMounted, onBeforeMount } from "vue";
import { judgeUrlType } from "@/utils/utils";
import lottie from 'lottie-web';
import lottieData from './data.json'

export default /*#__PURE__*/_defineComponent({
  __name: 'ExpireLottie',
  props: {
    // 试卷列表
    lottiePath: {
        type: String,
        default: () => '',
    },
},
  emits: ['closeHandler','openHandler'],
  setup(__props, { emit: $emit }) {

const props = __props;





const popImgType = computed(() => {
    return judgeUrlType(props.lottiePath);
});

const lottiePlay = () => {
    lottie.loadAnimation({
        container: document.getElementById("lottie-main"), // the dom element that will contain the animation
        renderer: 'svg',
        loop: true,
        autoplay: true,
        // animationData: lottieData  // the path to the animation jsonprops.lottiePath
        path: props?.lottiePath
    });
}


const closeHandler = () => {
    console.log('closeHandler')
    // curSelect.value = data.value
    $emit('closeHandler')
}

const openVip = () => {
    console.log('openHandler')
    // curSelect.value = data.value
    $emit('openHandler')
}
onMounted(()=>{
    lottiePlay()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (popImgType.value === 'img')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            src: __props.lottiePath,
            class: ""
          }, null, 8, _hoisted_3),
          _createElementVNode("div", {
            class: "tip",
            onClick: closeHandler
          }),
          _createElementVNode("div", {
            class: "hot-area",
            onClick: openVip
          })
        ]))
      : _createCommentVNode("", true),
    (popImgType.value === 'lottie')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "tip",
            onClick: closeHandler
          }),
          _createElementVNode("div", {
            class: "hot-area",
            onClick: openVip
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})